import React from "react";
import Tooltip from "@mui/material/Tooltip";
import Skeleton from "@mui/material/Skeleton";

const TableBody = ({ isSearching, tableData, columnSearch, highlightMatch }) => {
  return (
    <>
      {isSearching ? (
        [...Array(8)].map((_, i) => (
          <tr key={i} className="h-[35px]">
            {[
              "140px",
              "100px",
              "100px",
              "120px",
              "100px",
              "100px",
              "80px",
              "100px",
              "80px",
            ].map((w, j) => (
              <td key={j} className="p-[10px]">
                <Skeleton variant="text" height={20} style={{ width: w }} />
              </td>
            ))}
          </tr>
        ))
      ) : tableData.length > 0 ? (
        tableData.map((rule, index) => (
          <tr
            key={index}
            className={`w-full ${index % 2 === 0 ? "bg-white" : "bg-[#eee]"}`}
          >
            <td className="text-left align-middle w-[100px]">
              <Tooltip
                title={
                  rule.ruleName?.includes("|")
                    ? rule.ruleName.split("|")[1]?.trim()
                    : rule.ruleName || ""
                }
                slotProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: "#ece5e5ff",
                      color: "black",
                      fontSize: "12px",
                      fontFamily: "Poppins",
                      padding: "8px 10px",
                      borderRadius: "6px",
                    },
                  },
                }}
              >
                <span className="block font-poppins text-[10px] w-[100px] truncate">
                  {highlightMatch(
                    (() => {
                      const fullText = rule.ruleName?.includes("|")
                        ? rule.ruleName.split("|")[1]?.trim()
                        : rule.ruleName || "";
                      const words = fullText.split(/\s+/);
                      return words.length > 10
                        ? words.slice(0, 10).join(" ") + "..."
                        : fullText;
                    })(),
                    columnSearch.ruleName || columnSearch.allsearch
                  )}
                </span>
              </Tooltip>
            </td>

<td className="text-left align-middle w-[100px] text-[10px]">
              <span className="block text-[10px] truncate w-[80px]">
                {highlightMatch(
                  rule.rulePhase || "",
                  columnSearch.rulePhase || columnSearch.allsearch
                )}
              </span>
            </td>

<td className="text-left align-middle w-[100px] text-[10px]">
              <span className="block text-[10px] ">
                {highlightMatch(
                  rule.dqDimension
                    ? rule.dqDimension.charAt(0).toUpperCase() + rule.dqDimension.slice(1)
                    : "",
                  columnSearch.dqDimension || columnSearch.allsearch
                )}
              </span>
            </td>

<td className="text-left align-middle text-[10px]">
              <Tooltip
                title={
                  rule.dataAssetName?.includes("|")
                    ? rule.dataAssetName.split("|")[1]?.trim()
                    : rule.dataAssetName || ""
                }
                slotProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: "#ece5e5ff",
                      color: "black",
                      fontSize: "12px",
                      fontFamily: "Poppins",
                      padding: "8px 10px",
                      borderRadius: "6px",
                    },
                  },
                }}
              >
                <span className="block w-[100px] text-[10px] truncate">
                  {highlightMatch(
                    (() => {
                      const text = rule.dataAssetName?.includes("|")
                        ? rule.dataAssetName.split("|")[1]?.trim()
                        : rule.dataAssetName || "";
                      const words = text.split(/\s+/);
                      return words.length > 5
                        ? words.slice(0, 5).join(" ") + "..."
                        : text;
                    })(),
                    columnSearch.dataAssetName || columnSearch.allsearch
                  )}
                </span>
              </Tooltip>
            </td>

            <td className="text-left align-middle w-[100px]">
              {highlightMatch(
                rule.failPercentageVsThreshold || "",
                columnSearch.failPercentageVsThreshold || columnSearch.allsearch
              )}
            </td>

            <td className="text-left align-middle w-[100px]">
              {highlightMatch(
                rule.breachDate || "",
                columnSearch.breachDate || columnSearch.allsearch
              )}
            </td>

            <td className="text-left align-middle w-[100px]" >
              {highlightMatch(
                rule.Status || "",
                columnSearch.Status || columnSearch.allsearch
              )}
            </td>

            <td className="text-left align-middle w-[100px]">
              {highlightMatch(
                rule.ruleOwner || "",
                columnSearch.ruleOwner || columnSearch.allsearch
              )}
            </td>

       
            <td className="text-left align-middle w-[100px]">
  {rule.RecordLink && rule.Ticket !== "N/A" ? (
    <a
      href={rule.RecordLink}
      target="_blank"
      rel="noopener noreferrer"
      className="text-blue-600 underline hover:text-blue-800"
    >
      {highlightMatch(
        rule.Ticket || "",
        columnSearch.Ticket || columnSearch.allsearch
      )}
    </a>
  ) : (
    <span>
      {highlightMatch(
        rule.Ticket || "",
        columnSearch.Ticket || columnSearch.allsearch
      )}
    </span>
  )}
</td>

          </tr>
        ))
      ) : (
        <tr>
<td colSpan="10" className="text-center p-4">
            No records found
          </td>
        </tr>
      )}
    </>
  );
};

export default TableBody;
